import { FormSchema } from '@/forms/types/schema';
import { OrganisationFieldValues } from './field-values';

export const organisationFormSchema: FormSchema<OrganisationFieldValues> = {
  name: {
    type: 'text',
    label: 'Organisation name',
    value: '',
    validation: { required: true, maxLength: 64 },
  },
};
